(function() {
  function init() {
    if (typeof Integration === 'undefined') {
      return;
    }

    Integration.compileIntegrationTemplate = function(data, itemHtml) {
      var reviewsHtml = '<div class="andcollar-plp-stars"><div class="redo-review-stars" product_id="' + data.id + '"></div></div>';
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewsHtml);
      return itemHtml;
    };
  }
  init();
  document.addEventListener('DOMContentLoaded', init);
})();